import React from 'react';

import { Box, Stack } from '@chakra-ui/react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import NoMentorsImage from '@assets/noMentors.png';
import { PrimaryButton } from '@components/custom-buttons';
import { CustomText } from '@components/Custom-text';
import { paths } from '@routes/path';

export const NoMentorsAvailable = () => {
    const router = useRouter();
    const handleMentorSignup = () => {
        router.push(paths.mentor.auth.signup);
    };
    return (
        <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="70vh"
            p={3}
        >
            <Box mb={4}>
                <Image width={200} height={200} src={NoMentorsImage} alt="no mentors" />
            </Box>
            <CustomText color="titleText" textAlign="center" size="xl" weight={500}>
                We&apos;re Currently Onboarding Mentors!
            </CustomText>
            <CustomText color="subText" textAlign="center" size="md" weight={400}>
                Interested in becoming a mentor and giving back to the community? Sign up below.
            </CustomText>
            <Box mt={5}>
                <PrimaryButton
                    type="button"
                    buttonLabel="Become a Mentor"
                    onClick={handleMentorSignup}
                />
            </Box>
        </Stack>
    );
};
